import Vue from 'vue'
import urls from '../services.url.js'
import authHeaders from './headers'

export default {
  checkToken () {
    return Vue.http.get(urls.CHECK_TOKEN_URL, {'headers': authHeaders.getAuthHeaders()})
  },
  logout () {
    let tok = localStorage.getItem('key')
    return Vue.http.post(urls.LOGOUT_URL, tok, {'headers': authHeaders.getAuthHeaders()})
  },
  lostLogin (email) {
    let resetUrl = urls.CHANGE_PWD_URL
    let body = JSON.stringify({ resetUrl, email })
    return Vue.http.post(urls.LOST_LOGIN_URL, body)
  },
  changePwd (newPassword1, newPassword2, uid, token) {
    let body = {
      'new_password1': newPassword1,
      'new_password2': newPassword2,
      'uid': uid,
      'token': token }
    return Vue.http.post(urls.RESET_PWD_URL, body)
  },
  confirmEmail (key) {
    let body = JSON.stringify({ key })
    return Vue.http.post(urls.VERIFY_EMAIL_URL, body)
  },
  login (username, password) {
    var target = urls.LOGIN_URL
    let body = JSON.stringify({ username, password })
    return Vue.http.post(target, body)
  },
  facebookLogin (token) {
    var target = urls.CHECK_FACEBOOK_TOKEN_URL
    let body = JSON.stringify({token})
    return Vue.http.post(target, body)
  }
}



// WEBPACK FOOTER //
// ./src/api/real-api/auth.api.js